import { render } from "./GameControls.vue?vue&type=template&id=544f880c"
import script from "./GameControls.vue?vue&type=script&lang=js"
export * from "./GameControls.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__